import { type HTMLProps, type PropsWithChildren, useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import DefinitionPopover from '../DefinitionPopover/DefinitionPopover';
import remarkDefinitions from '../../utils/remark-definitions';

interface Props extends PropsWithChildren {
  content: string | undefined;
  type: string;
}

function DCFMarkdown({ content, type }: Props) {
  function className(type: string) {
    switch (type) {
      case 'subtitle':
        return 'govuk-heading-m';
      case 'description':
        return 'govuk-body';
      case 'hint-text':
        return 'govuk-hint';
      default:
        return 'govuk-body';
    }
  }

  const components = {
    span: useCallback(
      ({
        node,
        children,
      }: {
        node?: { properties?: Record<string, unknown> };
        children?: React.ReactNode;
      }) => {
        const definition = node?.properties?.['data-definition'];
        const term = node?.properties?.['data-term'];
        return typeof definition === 'string' && typeof term === 'string' ? (
          <DefinitionPopover definition={definition} term={term} />
        ) : (
          <span>{children}</span>
        );
      },
      [],
    ),
    a: useCallback(
      (props: HTMLProps<HTMLAnchorElement>) => (
        <a href={props.href} className="govuk-link">
          {props.children}
        </a>
      ),
      [],
    ),
    ul: useCallback(
      (props: HTMLProps<HTMLUListElement>) => (
        <ul className="govuk-list govuk-list--bullet">{props.children}</ul>
      ),
      [],
    ),
  };
  return (
    <ReactMarkdown
      className={className(type)}
      components={components}
      remarkPlugins={[remarkDefinitions]}
    >
      {content}
    </ReactMarkdown>
  );
}

export default DCFMarkdown;
